import React, { useState, useEffect } from 'react';

// Libraries/Packages
import VerificationInput from 'react-verification-input';

// Hooks
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

// Actions
import { verifyUserToken, ForgotUserPassword } from '~/redux/actions/auth-actions';
import { success, failure } from '~/redux/actions/snackbar-actions';

// Utils
import { getResetToken, getUserEmail } from '~/utils/auth';
import { MESSAGES } from '~/utils/message';

// Icons
import { OnBoardCIcon } from '~/assets/images';
import { Box, InputLabel, Typography, Button, CircularProgress } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import OlcButton from '~/components/General/OlcButton';

// Styles
import '../../index.scss';
import '../CreateAccountNew/styles.scss';
import './styles.scss';

const Verification = () => {
  const [loading, setLoading] = useState(false);
  const [code, setCode] = useState('');
  const [searchParams] = useSearchParams();
  const [resendingCode, setResendingCode] = useState(false);
  let token = getResetToken();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const verifyCode = async (resetCode = code, resetToken = token) => {
    try {
      const payload = {
        code: resetCode,
        token: resetToken,
      };
      setLoading(true);
      const request = await dispatch(verifyUserToken(payload));
      setLoading(false);
      if (request.message === 'success') {
        navigate('/update-password');
      } else {
        dispatch(failure(request?.response?.data?.message || MESSAGES.GENERAL_ERROR));
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const reSendCode = async () => {
    try {
      setResendingCode(true);
      const payload = {
        email: getUserEmail(),
      };
      const request = await dispatch(ForgotUserPassword(payload));
      setResendingCode(false);
      if (request.message === 'success') {
        setResendingCode(false);
        dispatch(
          success(request?.response?.data?.message || MESSAGES.AUTH.RESET_CODE + getUserEmail())
        );
      } else {
        dispatch(failure(request?.response?.data?.message || MESSAGES.GENERAL_ERROR));
      }
    } catch (error) {
      setResendingCode(false);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (loading || code.length < 8) return;
    verifyCode();
  };

  useEffect(() => {
    if (searchParams.size > 0) {
      if (searchParams.get('code')) {
        let paramsCode = searchParams.get('code');
        let paramsToken = searchParams.get('token');
        setCode(searchParams.get('code'));
        verifyCode(paramsCode, paramsToken);
      }
    }
  }, []);

  return (
    <Box className="newCreateAccountWrapper verificationPageWrapper">
      <Box className="topIconWrapper">
        <img src={OnBoardCIcon} alt="OpenLetter" />
      </Box>
      <Box className="createAccountFormWrapper verificationFormCard">
        <Box className="verificationBackButton">
          <ArrowBackIcon
            onClick={() => {
              navigate('/reset-password');
            }}
          />
        </Box>
        <Box className="createAccountFormHeader verificationFormHeader">
          <Typography variant="h4">{MESSAGES.VERIFICATION.TITLE}</Typography>
          <Typography>{MESSAGES.VERIFICATION.HEADING}</Typography>
        </Box>
        <form className="verificationForm" onSubmit={handleSubmit}>
          <Box className="newInputWrapper verificationCodeWrapper">
            <InputLabel className="formLabel">
              {MESSAGES.VERIFICATION.INPUT_LABEL_CODE}
            </InputLabel>
            <VerificationInput
              classNames={{
                container: 'verificationCodeContainer',
                character: 'verificationCodeCharacter',
                characterInactive: 'character--inactive',
                characterSelected: 'character--selected',
              }}
              placeholder="0"
              length={8}
              value={code}
              autoFocus={true}
              onChange={(event) => setCode(event)}
              onComplete={(event) => verifyCode(event)}
            />
          </Box>
          <OlcButton
            variant="primary"
            className="submitButton verificationSubmitButton"
            type="submit"
            disabled={loading || code.length < 8}
          >
            {loading ? (
              <CircularProgress
                sx={{
                  color: 'white',
                  width: '25px !important',
                  height: '25px !important',
                }}
              />
            ) : (
              MESSAGES.VERIFICATION.SUBMIT_BUTTON
            )}
          </OlcButton>
        </form>
        <Button
          className="verificationResendButton"
          disabled={resendingCode}
          onClick={reSendCode}
        >
          {MESSAGES.VERIFICATION.RESEND_BUTTON}
        </Button>
      </Box>
    </Box>
  );
};

export default Verification;
